export default {
  namespaced: true,
  state: {
    selectedParameters: [],
    selectedLimits: [],
    selectedParameterGroups: [],
  },
  actions: {
    setSelectedParameters({ commit }, value) {
      commit('setSelectedParameters', value);
    },
    setSelectedLimits({ commit }, value) {
      commit('setSelectedLimits', value);
    },
    setSelectedParameterGroup({ commit }, value) {
      commit('setSelectedParameterGroup', value);
    },
    includesCMA({ state }) {
      if (state.selectedLimits.length > 0) {
        return state.selectedLimits[0].toString().includes('CMA');
      }

      return false;
    },
    clearFilters({ commit }) {
      commit('clearFilters');
    },
  },
  mutations: {
    setSelectedParameters(state, value) {
      state.selectedParameters = value;
    },
    setSelectedParameterGroup(state, value) {
      state.selectedParameterGroups = value;
    },
    setSelectedLimits(state, value) {
      state.selectedLimits = value;
    },
    clearFilters(state) {
      state.selectedParameters = [];
      state.selectedLimits = [];
      state.selectedParameterGroups = [];
    },
  },
};
